import * as React from "react"
import cx from "classnames"

import {
  FlowQuestionLayout,
  FlowUserAnswer,
  FlowPickOneAnswer,
  FlowInputCallback,
  FlowQuestionId,
} from "types"
import { HeadingSize } from "../Button"
import * as styles from "./styles.module.scss"
import Button from "../../Flow/Button"

export interface InputPickOneProps {
  answers: FlowPickOneAnswer[]
  flowKey: FlowQuestionId
  layout?: FlowQuestionLayout
  nextCallback?: Function
  onSubmit: FlowInputCallback
  userAnswer?: FlowUserAnswer
}

const InputPickOne: React.FC<InputPickOneProps> = ({
  answers,
  flowKey,
  layout = FlowQuestionLayout.Grid,
  nextCallback,
  onSubmit,
  userAnswer,
}) => {
  const onSubmitFormat = (value: string, display: string) => {
    onSubmit({
      flowKey,
      value: value.toLowerCase(),
      display,
    })
  }

  return (
    <div
      className={cx({
        [styles.pickOne]: true,
        [styles.list]: layout === FlowQuestionLayout.List,
        [styles.grid]: layout === FlowQuestionLayout.Grid,
      })}
    >
      <div className={styles.container}>
        <ul className={styles.answers}>
          {answers.map((answer) => {
            const isSelected = userAnswer?.value?.toString() === answer.id
            return (
              <li
                className={cx({
                  [styles.listItem]: layout === FlowQuestionLayout.List,
                  [styles.gridItem]: layout === FlowQuestionLayout.Grid,
                  [styles.selected]: isSelected,
                })}
                data-flow-value={answer.id}
                data-flow-display-value={answer.title}
                data-qa-answer-type="select"
                data-qa="answer"
                data-flow-key={flowKey}
                key={`${flowKey}-${answer.id}`}
                onClick={() => onSubmitFormat(answer.id, answer.title)}
              >
                {layout === FlowQuestionLayout.Grid ? (
                  <div className={styles.wrapper}>
                    <div className={styles.box}>
                      <Button
                        data-flow-next-callback={nextCallback}
                        headingSize={HeadingSize.Large}
                        heading={answer.title}
                        subhead={answer.detail}
                      ></Button>
                    </div>
                  </div>
                ) : (
                  <Button
                    data-flow-next-callback={nextCallback}
                    headingSize={HeadingSize.Medium}
                    heading={answer.title}
                    subhead={answer.detail}
                  ></Button>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default InputPickOne
